import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { AppConfig } from "../../configs/app";
import { CommonService } from "../../services/common.service";
import { AuthService } from "../../services/auth.service";
import { PlanService } from "../../services/plan.service";
import { CartService } from "../../services/cart.service";
import { ReservationService } from "../../services/reservation.service";
import { CacheService } from "../../services/cache.service";
import { AnalyticsService } from "../../services/analytics.service";

declare var Cleave: any;

@Component({
  selector: "layout-partial",
  templateUrl: "./layout-partial.component.html",
})
export class LayoutPartialComponent implements OnInit {
  @Input() currentHistoryTab: any;
  /* header, footer, login, planSearch, searchReservation */
  @Input() view: any;
  @Input() redirect: boolean = false;
  @Input() noReservation: boolean = true;
  @Input() activatedStation: any = {};
  @Input()
  set inputEvent(data: any) {
    if (data && data.event) {
      switch (data.event) {
        case "openFilter":
          this.filterData.isViewingCalendar = true;
          this.openFilter();
          /* CHECK FOR RETURN PLAN */
          if (data.returnPlan) {
            this.reverseDivisions();
            this.filterData.targetDay = data.returnPlan;
          }
          /* END */
          break;
      }
    }
  }

  @Output() currentHistoryTabChange = new EventEmitter<any>();
  @Output() clickCallback = new EventEmitter<any>();
  @Output() loginFormCallback = new EventEmitter<any>();
  @Output() setActivatedStation = new EventEmitter<any>();
  @Output() getFavouritePlans = new EventEmitter<any>();
  @Output() getViewedPlans = new EventEmitter<any>();

  public viewedPlans: any = {};
  @Input() set _viewedPlans(data: any) {
    this.viewedPlans = data;
  }

  public favouritePlans: any = {};
  @Input() set _favouritePlans(data: any) {
    this.favouritePlans = data;
  }

  public cartQuantity: number = 0;
  @Input() set _cartQuantity(data: any) {
    this.cartQuantity = data;
  }

  public $: any;
  public moment: any;
  public _: any;

  public loginForm: FormGroup;
  public forgotPasswordForm: FormGroup;
  public searchReservationForm: FormGroup;

  public isLoggedIn: boolean = false;

  /* CUSTOM VALIDATOR */
  public myValidator: any = {};

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  /* SEARCH BELOW */
  public searchParams: any = {};
  public filterData: any = {};

  public planList: any = [];
  public pagination: any = {};
  public targetDay: string;
  public calendarDate: string;
  public hasTargetDay: boolean;
  public monthJustChanged: boolean;
  public initDate: string; /* AS SELECTED/ACTIVE DATE */
  public city: string;
  public town: string;

  constructor(
    public activatedRoute: ActivatedRoute,
    public location: Location,
    public appConfig: AppConfig,
    public formBuilder: FormBuilder,
    public commonService: CommonService,
    public authService: AuthService,
    public planService: PlanService,
    public cartService: CartService,
    public reservationService: ReservationService,
    public cacheService: CacheService,
    private analyticsService: AnalyticsService
  ) {
    let self = this;
    this.$ = this.commonService.getJQuery();
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();

    /* CUSTOM VALIDATOR */
    this.myValidator.isNumeric = function (control: AbstractControl): any {
      if (
        control.value &&
        control.value != "" &&
        !self.commonService.isNumeric(control.value)
      ) {
        return { isNumeric: true };
      }
      return null;
    };

    this.myValidator.validDate = function (inputName: string = "") {
      return function (control: AbstractControl): any {
        let value = control.value.toString().replace(/[/]/g, "");
        if (value.length < 8) {
          return { validDate: true };
        }
        if (self.moment(value, "YYYYMMDD", true).isValid() !== true) {
          return { validDate: true };
        }
        return null;
      };
    };
    /* END */

    /* VIEWED & FAVOURITE PLANS */
    this.viewedPlans = {
      keyMap: {},
      list: [],
    };

    this.favouritePlans = {
      keyMap: {},
      list: [],
    };

    /* SEARCH BELOW */
    /*
            SET INIT DATE
            IF NOW IS GREATER THAN 18, SET INIT DATE TO THE NEXT DAY
        */
    if (this.moment().hour() < 18) {
      this.initDate = this.moment().format("YYYYMMDD");
    } else {
      this.initDate = this.moment().add(1, "days").format("YYYYMMDD");
    }
    /* END */
    this.targetDay = this.initDate;
    this.hasTargetDay = false;
    // 【2026-08-01修正】価格カレンダーのデータ取得起点は「実際の今日」に固定する。
    // 従来は initDate(18時以降は翌日)を起点にしていたため、月末日の18時以降は
    // 取得月が翌月〜4ヶ月先にずれ、当月の価格データが1件も取得されず、
    // カレンダー上で当日(および当月全日)がクリック不可になっていた
    // (クリック可否は _bestPriceList にその日のエントリがあるかで決まる)。
    // 例: 7/31 18:40、乗車日に当日7/31を選択できない(大串さん2026-07-31報告)。
    // initDate(初期選択日)の18時ルールは従来どおり維持=夕方以降の既定日は翌日のまま。
    this.calendarDate = this.moment().format("YYYYMMDD");
    this.monthJustChanged = true;

    /* FILTER DATA */
    this.filterData = {
      targetDay: this.targetDay,
      isViewingCalendar: false,
      cityChoosingType: "departure",
      sort: 1,

      bestPriceList: {
        thisMonth: {},
        nextMonth: {},
        next2Month: {},
        next3Month: {},
      },

      divisionData: {},
      townData: {
        departure: {},
        destination: {},
      },

      departureYMD: this.targetDay,
      departureCityID: "",
      destinationCityID: "",
      departureTownID: "",
      destinationTownID: "",

      /* PLAN OPTIONS */
      planOptions: this.planService.getPlanOptions(),
      chosenOptions: {},
      tempChosenOptions: {},
    };

    /* PAGINATION */
    this.pagination = {
      offset: 0,
      limit: this.appConfig.plan.searchPageLimits,
      totalPlans: 0,
      currentPage: 1,
      hasPrev: false,
      hasNext: false,
      lastItemSeq: "-",
    };

    /* TEMP DATA */
    this.tempData.currentHistoryTab = 1;

    /* RUN INLINE JAVASCRIPT */
    this.inlineJSRunOnce();
  }

  async ngOnInit() {
    this.isLoggedIn = this.authService.isLoggedIn();

    /* GET VIEWED & FAVOURITE PLANS */
    let data = this.planService.getViewedPlans();
    if (data) {
      this.viewedPlans = data;
    }

    data = this.planService.getFavouritePlans();
    if (data) {
      this.favouritePlans = data;
    }
    /* END */

    /* CART QUANTITY */
    let cartData = this.cartService.getCartData();
    if (cartData) {
      this.cartQuantity = cartData.length;
    }

    /* INIT LOGIN FORM */
    if (!this.authService.isLoggedIn()) {
      this.loginForm = this.formBuilder.group({
        email: ["", [Validators.required]],
        password: ["", [Validators.required]],
      });

      /* INIT FORGOT PASSWORD FORM */
      this.forgotPasswordForm = this.formBuilder.group({
        email: ["", [Validators.required, Validators.email]],
        birthday: ["", [Validators.required, this.myValidator.validDate()]],
      });

      /* SET TEMP DATA */
      this.tempData.loginFormSubmitted = false;
      this.tempData.forgotPasswordForm = false;
      /* END */
    }

    /* INIT SEARCH RESERVATION FORM */
    this.searchReservationForm = this.formBuilder.group({
      reservationID: ["", [Validators.required, this.myValidator.isNumeric]],
      tel: [
        "",
        [
          Validators.required,
          this.myValidator.isNumeric,
          Validators.minLength(10),
          Validators.maxLength(11),
        ],
      ],
    });
    /* END */

    /* SEARCH BELOW */
    if (this.view && this.view.planSearch) {
      this.initSearchView();
    }

    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();
  }

  async initSearchView() {
    /* GET PLAN DATA */
    let targetDay = this.activatedRoute.snapshot.paramMap.get("targetDay");
    this.city = this.activatedRoute.snapshot.paramMap.get("city");
    this.town = this.activatedRoute.snapshot.paramMap.get("town");

    if (
      targetDay &&
      this.moment(targetDay, "YYYYMMDD", true).isValid() === true
    ) {
      this.targetDay = targetDay;
      this.hasTargetDay = true;
      this.filterData.targetDay = targetDay;
    } else {
      this.targetDay = this.initDate;
      this.hasTargetDay = false;
      this.filterData.targetDay = this.initDate;
    }

    /* INIT SEARCH & FILTER DATA */
    await this.initSearchNFilterData();

    this.monthJustChanged = true;
  }

  userLogout() {
    /* CLOSE ALL MODALS */
    this.$(".modal").modal("hide");

    /* DO LOGOUT */
    this.authService.logout();

    /* REDIRECT THEN */
    window.location.href = window.location.origin;
  }

  _clickCallback(data: any) {
    this.clickCallback.emit(data);
  }

  changeTab(tab: any) {
    this.currentHistoryTab = tab;
    this.currentHistoryTabChange.emit(tab);
  }

  async submitLogin() {
    this.tempData.loginFormSubmitted = true;

    if (this.loginForm.invalid) {
      return false;
    }

    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    let returnData: any = await this.authService.loginWithEmail({
      email: this.loginForm.controls["email"].value,
      password: this.loginForm.controls["password"].value,
    });

    /* CHECK LOGIN STATUS */
    /* CALLBACK */
    returnData.type =
      this.commonService.appConfig.reservation.registerWithBookingOff;
    this._loginFormCallback(returnData);
    if (returnData.status == "success") {
      this.tempData.loginErrorMessage = "";
      if (!this.redirect) {
        window.location.href = window.location.origin + "/mypages";
      }
    } else {
      this.tempData.loginErrorMessage = returnData.message;
    }

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  async submitForgotPassword() {
    this.tempData.forgotPasswordFormSubmitted = true;

    /* FORM ZEN TO HAN */
    this.commonService.convertFormInputZenToHan(this.forgotPasswordForm);
    this.formValidationInit();

    if (this.forgotPasswordForm.invalid) {
      return false;
    }

    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    let dateParts =
      this.forgotPasswordForm.controls["birthday"].value.split("/");

    if (dateParts.length > 2) {
      let returnData = await this.authService.forgotPassword({
        email: this.forgotPasswordForm.controls["email"].value,
        year: dateParts[0],
        month: dateParts[1],
        day: dateParts[2],
      });

      if (returnData.status == "success") {
        /* RESET FORM */
        this.tempData.forgotPasswordFormSubmitted = false;
        this.forgotPasswordForm.controls["email"].setValue("");
        this.forgotPasswordForm.controls["birthday"].setValue("");
        /* END */

        this.tempData.forgotPasswordSuccessMessage = returnData.message;
        this.tempData.forgotPasswordErrorMessage = "";
      } else {
        this.tempData.forgotPasswordSuccessMessage = "";
        this.tempData.forgotPasswordErrorMessage = returnData.message;
      }
    }

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  async submitSearchReservation() {
    this.tempData.searchReservationFormSubmitted = true;
    this.tempData.searchReservationErrorMessage = null;

    /* FORM ZEN TO HAN */
    this.commonService.convertFormInputZenToHan(this.searchReservationForm);
    this.formValidationInit();

    if (this.searchReservationForm.invalid) {
      return false;
    }

    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* GET RESERVATION DATA */
    let reservationData: any =
      await this.reservationService.findReservationByID({
        reservationID: this.searchReservationForm.controls.reservationID.value,
        tel: this.searchReservationForm.controls.tel.value,
        busDetail: 1,
        emailDetail: 1,
      });

    if (!this._.isEmpty(reservationData.reservation)) {
      /* RESET FORM */
      this.tempData.searchReservationFormSubmitted = false;
      this.tempData.searchReservationErrorMessage = null;

      /* REDIRECT TO RESERVATION DETAIL PAGE */
      this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReservationDetailNoParam,
        [this.searchReservationForm.controls.reservationID.value]
      );

      if (
        location.href.indexOf(
          this.commonService.routePaths.pageReservationDetailNoParam
        ) !== -1
      ) {
        setTimeout(function () {
          window.location.reload();
        }, 200);
      } else {
        this.$(".modal").modal("hide");
      }
      /* TODO */
    } else {
      this.tempData.searchReservationErrorMessage = "ERROR";
    }

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  loginWithSocialAccount(type: any) {
    /* CHECK IF LOGGING-IN BY RESERVATION FLOW */
    if (this.redirect) {
      this.commonService.setCurrentURL(
        window.location.origin +
          this.commonService.routePaths.pageReserveIndexNoParam
      );
    } else {
      this.commonService.setCurrentURL(
        window.location.origin +
          this.commonService.routePaths.pageMyPageIndexNoParam
      );
    }

    switch (type) {
      case 1 /* FACEBOOK */:
        this.authService.redirectToFacebookLogin();
        break;

      case 2 /* LINE */:
        this.authService.redirectToLineLogin();
        break;

      case 3 /* GOOGLE */:
        this.authService.redirectToGoogleLogin();
        break;

      case 4 /* YAHOO JP */:
        this.authService.redirectToYahooJPLogin();
        break;

      case 5 /* INSTAGRAM */:
        this.authService.redirectToInstagramLogin();
        break;

      case 6 /* TWITTER */:
        this.authService.redirectToTwitterLogin();
        break;
    }
  }

  /* PARENT */
  _loginFormCallback(event: any = {}) {
    this.loginFormCallback.emit(event);
  }

  /* SEARCH BELOW */
  async initSearchNFilterData() {
    /* SEARCH PARAMS */
    this.searchParams = {
      departureYMD: this.targetDay,
      departureCityID: "",
      destinationCityID: "",
      departureTownID: "",
      destinationTownID: "",
      planOptions: "",
      offset: this.pagination.offset,
      limit: this.pagination.limit,
      sort: 1 /* 1:料金安い順 2:料金高い順 3:出発時刻早い順 4:出発時刻遅い順 省略時は1 */,
    };

    /* GET SAVED FILTER DATA */
    let savedFilterData = this.planService.getFilterOptions();
    if (!this._.isEmpty(savedFilterData)) {
      if (
        !this.hasTargetDay &&
        this.moment(savedFilterData.departureYMD).valueOf() >
          this.moment(this.targetDay).valueOf()
      ) {
        this.targetDay = savedFilterData.departureYMD;
        this.searchParams.departureYMD = this.targetDay;
        this.filterData.targetDay = this.targetDay;
      }

      this.searchParams.departureCityID = savedFilterData.departureCityID;
      this.searchParams.destinationCityID = savedFilterData.destinationCityID;
      this.searchParams.departureTownID = savedFilterData.departureTownID;
      this.searchParams.destinationTownID = savedFilterData.destinationTownID;
      this.searchParams.planOptions = savedFilterData.planOptions;
      this.searchParams.sort = savedFilterData.sort;

      this.filterData.chosenOptions = savedFilterData.chosenOptions;
      this.filterData.townData = savedFilterData.townData;
    }

    /* GET DIVISION DATA */
    this.filterData.divisionData = await this.planService.getDivisions();
    /* END */

    /* SET CITY & TOWN DATA FROM URL PARAM */
    /* CITY */
    if (!this._.isEmpty(this.city)) {
      let cityArr = this.city.split("_");
      if (cityArr.length === 1) {
        if (
          this._.has(
            this.filterData.divisionData,
            `division_map.slug.${cityArr[0]}`
          )
        ) {
          this.searchParams.departureCityID =
            this.filterData.divisionData.division_map.slug[cityArr[0]].id_bb;
          this.searchParams.destinationCityID = "";
        } else {
          this.searchParams.departureCityID = "";
          this.searchParams.destinationCityID = "";
        }
      } else if (cityArr.length > 1) {
        if (
          this._.has(
            this.filterData.divisionData,
            `division_map.slug.${cityArr[0]}`
          )
        ) {
          this.searchParams.departureCityID =
            this.filterData.divisionData.division_map.slug[cityArr[0]].id_bb;
        } else {
          this.searchParams.departureCityID = "";
        }

        if (
          this._.has(
            this.filterData.divisionData,
            `division_map.slug.${cityArr[1]}`
          )
        ) {
          this.searchParams.destinationCityID =
            this.filterData.divisionData.division_map.slug[cityArr[1]].id_bb;
        } else {
          this.searchParams.destinationCityID = "";
        }
      }
    }

    /* TOWN */
    if (!this._.isEmpty(this.town)) {
      let townArr = this.town.split("_");
      if (townArr.length === 1) {
        this.filterData.cityChoosingType = "departure";
        await this.getTowns(this.searchParams.departureCityID);
        if (
          this._.has(
            this.filterData.townData,
            `departure.map.slug.${townArr[0]}`
          )
        ) {
          this.searchParams.departureTownID =
            this.filterData.townData.departure.map.slug[townArr[0]].id;
          this.searchParams.destinationTownID = "";
        } else {
          this.searchParams.departureTownID = "";
          this.searchParams.destinationTownID = "";
        }
      } else if (townArr.length > 1) {
        this.filterData.cityChoosingType = "departure";
        await this.getTowns(this.searchParams.departureCityID);
        this.filterData.cityChoosingType = "destination";
        await this.getTowns(this.searchParams.destinationCityID);
        if (
          this._.has(
            this.filterData.townData,
            `departure.map.slug.${townArr[0]}`
          )
        ) {
          this.searchParams.departureTownID =
            this.filterData.townData.departure.map.slug[townArr[0]].id;
        } else {
          this.searchParams.departureTownID = "";
        }

        if (
          this._.has(
            this.filterData.townData,
            `destination.map.slug.${townArr[1]}`
          )
        ) {
          this.searchParams.destinationTownID =
            this.filterData.townData.destination.map.slug[townArr[1]].id;
        } else {
          this.searchParams.destinationTownID = "";
        }
      }
    } else if (!this._.isEmpty(this.city)) {
      this.searchParams.departureTownID = "";
      this.searchParams.destinationTownID = "";
    }
    /* END */

    /* SET FILTER DATA */
    this.filterData.departureYMD = this.searchParams.departureYMD;
    this.filterData.departureCityID = this.searchParams.departureCityID;
    this.filterData.destinationCityID = this.searchParams.destinationCityID;
    this.filterData.departureTownID = this.searchParams.departureTownID;
    this.filterData.destinationTownID = this.searchParams.destinationTownID;
    this.filterData.sort = this.searchParams.sort;
    /* END */
  }

  /* FILTER */
  changeCity(id: any, type: any) {
    if (type == "departure") {
      this.filterData.departureCityID = id;
      this.filterData.departureTownID = "";
      /* CHANGE TO NEXT TAB */
      this.filterData.cityChoosingType = "destination";
      this.filterData.isViewingCalendar = false;
    } else {
      this.filterData.destinationCityID = id;
      this.filterData.destinationTownID = "";
      /* CHANGE TO NEXT TAB */
      this.filterData.isViewingCalendar = true;
      this.getFilterCalendarPrices();
    }
  }

  getCityName(id: any, type: any = null) {
    if (this._.has(this.filterData.divisionData, `division_map.id_bb.${id}`)) {
      return this.filterData.divisionData.division_map.id_bb[id].name;
    }

    if (this._.isEmpty(type)) {
      return "---";
    }

    if (type == "departure") {
      return "出発地を選択";
    }
    return "到着地を選択";
  }

  getTownName(id: any, type: any) {
    if (type == "departure") {
      if (this._.has(this.filterData.townData.departure, `map.id_bb.${id}`)) {
        return this.filterData.townData.departure.map.id_bb[id].name;
      }
    } else {
      if (this._.has(this.filterData.townData.destination, `map.id_bb.${id}`)) {
        return this.filterData.townData.destination.map.id_bb[id].name;
      }
    }
    return "---";
  }

  async getTowns(cityID: any) {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");
    let townData: any = await this.planService.getTowns(cityID);
    if (this.filterData.cityChoosingType == "departure") {
      this.filterData.townData.departure = townData;

      /* CHOOSE FIRST IF EMPTY */
      if (this.filterData.departureTownID == "") {
        this.filterData.departureTownID =
          this.filterData.townData.departure.list[0].id;
      }
    } else {
      /* DESTINATION */
      this.filterData.townData.destination = townData;

      /* CHOOSE FIRST IF EMPTY */
      if (this.filterData.destinationTownID == "") {
        this.filterData.destinationTownID =
          this.filterData.townData.destination.list[0].id;
      }
    }

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  checkActiveDivisionChildren(parent: any, isFirst: boolean = false) {
    /* IF departureCityID OR destinationCityID IS EMPTY THEN EXPANDING THE FIRST CARD */
    if (isFirst) {
      let firstItem = this.$("#mdl-area .accordion .card").first();
      if (
        this.filterData.cityChoosingType == "departure" &&
        this.filterData.departureCityID == ""
      ) {
        firstItem
          .find(".text-body[aria-expanded]")
          .attr("aria-expanded", "true");
        firstItem.find(".collapse").addClass("show");
        return true;
      } else if (
        this.filterData.cityChoosingType == "destination" &&
        this.filterData.destinationCityID == ""
      ) {
        firstItem
          .find(".text-body[aria-expanded]")
          .attr("aria-expanded", "true");
        firstItem.find(".collapse").addClass("show");
        return true;
      }
    }

    let returnData = false;
    if (parent && this.filterData.divisionData.division[parent]) {
      for (let item of this.filterData.divisionData.division[parent]) {
        if (
          (this.filterData.cityChoosingType == "departure" &&
            item.id_bb == this.filterData.departureCityID) ||
          (this.filterData.cityChoosingType == "destination" &&
            item.id_bb == this.filterData.destinationCityID)
        ) {
          returnData = true;
          break;
        }
      }
    }
    return returnData;
  }

  checkActivePlanOptions(index: number, heading: any) {
    if (this._.has(this.filterData.chosenOptions, `${heading}.${index}`)) {
      return true;
    }
    return false;
  }

  setPlanOptions(index: number, heading: any, code: any) {
    if (!this.filterData.chosenOptions.hasOwnProperty(heading)) {
      this.filterData.chosenOptions[heading] = {};
      this.filterData.chosenOptions[heading][index] = code;
    } else {
      if (this.filterData.chosenOptions[heading].hasOwnProperty(index)) {
        delete this.filterData.chosenOptions[heading][index];
      } else {
        this.filterData.chosenOptions[heading][index] = code;
      }
    }
  }

  getChosenPlanOptions() {
    let options = [];
    for (let heading in this.filterData.chosenOptions) {
      for (let option in this.filterData.chosenOptions[heading]) {
        options.push(this.filterData.chosenOptions[heading][option]);
      }
    }
    return this._.uniq(options).join("|");
  }

  /* OPEN FILTER */
  openFilter() {
    let departureYMD = this.searchParams.departureYMD;
    this.filterData.departureYMD = departureYMD;
    this.tempData.filterTargetDay = this.filterData.targetDay;

    /* PLAN OPTIONS */
    this.filterData.tempChosenOptions = JSON.parse(
      JSON.stringify(this.filterData.chosenOptions)
    );
  }

  /* APPLY FILTER */
  async applyFilter() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* SET FILTER DATA */
    this.filterData.departureYMD = this.moment(
      this.filterData.targetDay
    ).format("YYYYMMDD");

    this.searchParams.departureYMD = this.filterData.departureYMD;
    this.searchParams.departureCityID = this.filterData.departureCityID;
    this.searchParams.destinationCityID = this.filterData.destinationCityID;
    this.searchParams.departureTownID = this.filterData.departureTownID;
    this.searchParams.destinationTownID = this.filterData.destinationTownID;

    this.filterData.tempChosenOptions = this.filterData.chosenOptions;
    /* END */

    /* SET DATA FOR GETTING LIST */
    this.pagination.currentPage = 1; /* BACK TO THE FIRST PAGE */
    this.targetDay = this.searchParams.departureYMD;
    this.hasTargetDay = true;
    this.monthJustChanged = true;

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  doSearch() {
    /* APPLY & SAVE FILTER OPTIONS */
    this.applyFilter();
    this.saveFilter();
    this.analyticsService.search("header", this.searchParams, this.filterData);

    return this.updateURL(
      {
        date: this.searchParams.departureYMD,
      },
      true
    );
  }

  /* CANCEL FILTER */
  async cancelFilter() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* SET FILTER DATA */
    this.targetDay = this.filterData.departureYMD;
    this.searchParams.departureYMD = this.filterData.departureYMD;

    this.filterData.targetDay = this.tempData.filterTargetDay;
    this.filterData.departureCityID = this.searchParams.departureCityID;
    this.filterData.destinationCityID = this.searchParams.destinationCityID;
    this.filterData.departureTownID = this.searchParams.departureTownID;
    this.filterData.destinationTownID = this.searchParams.destinationTownID;

    this.filterData.chosenOptions = this.filterData.tempChosenOptions;
    /* END */

    /* await this.getPlanList(); */

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  reverseDivisions(forceChange: boolean = false) {
    let valData = {
      departureCityID: this.filterData.departureCityID,
      destinationCityID: this.filterData.destinationCityID,
      departureTownID: this.filterData.departureTownID,
      destinationTownID: this.filterData.destinationTownID,

      townData: {
        departure: this.filterData.townData.departure,
        destination: this.filterData.townData.destination,
      },
    };

    this.filterData.departureCityID = valData.destinationCityID;
    this.filterData.destinationCityID = valData.departureCityID;
    this.filterData.departureTownID = valData.destinationTownID;
    this.filterData.destinationTownID = valData.departureTownID;

    this.filterData.townData.departure = valData.townData.destination;
    this.filterData.townData.destination = valData.townData.departure;

    if (forceChange === true) {
      this.searchParams.departureCityID = valData.destinationCityID;
      this.searchParams.destinationCityID = valData.departureCityID;
      this.searchParams.departureTownID = valData.destinationTownID;
      this.searchParams.destinationTownID = valData.departureTownID;

      /* APPLY FILTER OPTIONS */
      this.applyFilter();
    }
  }

  onFilterDateChanged(data: any) {
    this.filterData.targetDay = data.date;
  }

  saveFilter() {
    this.planService.saveFilterOptions({
      departureYMD: this.searchParams.departureYMD,
      departureCityID: this.searchParams.departureCityID,
      destinationCityID: this.searchParams.destinationCityID,
      departureTownID: this.searchParams.departureTownID,
      destinationTownID: this.searchParams.destinationTownID,
      planOptions: this.searchParams.planOptions,
      sort: this.searchParams.sort,
      chosenOptions: this.filterData.chosenOptions,
      townData: this.filterData.townData,
    });

    /* SAVE CACHE */
    this.cacheService.setData(
      this.appConfig.plan.divisionDataSessionName,
      this.filterData.divisionData
    );
  }
  /* END */

  async getPlanList() {
    this.pagination.totalPlans = 0;
    this.pagination.lastItemSeq = "-";
    this.pagination.offset =
      (this.pagination.currentPage - 1) * this.pagination.limit;
    this.searchParams.offset = this.pagination.offset;
    this.searchParams.planOptions = this.getChosenPlanOptions();

    /* GET PLAN LIST */
    let data = await this.planService.getPlanList(this.searchParams);
    this.planList = data.list;
    this.pagination.totalPlans = data.totalPlans;
  }

  /* BELONGS TO CALENDAR */
  async getFilterCalendarPrices() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* THIS MONTH */
    let searchParams = {
      departureYMD: this.calendarDate,
      departureCityID: this.filterData.departureCityID,
      destinationCityID: this.filterData.destinationCityID,
      departureTownID: this.filterData.departureTownID,
      destinationTownID: this.filterData.destinationTownID,
      planOptions: this.getChosenPlanOptions(),
      sort: 1,
      offset: 0,
      limit: 1,
    };

    let thisMonth = searchParams.departureYMD;

    let searchParamsNextMonth = JSON.parse(JSON.stringify(searchParams));
    searchParamsNextMonth.departureYMD = this.moment(thisMonth, "YYYYMM")
      .add(1, "months")
      .format("YYYYMMDD");

    let searchParamsNext2Month = JSON.parse(JSON.stringify(searchParams));
    searchParamsNext2Month.departureYMD = this.moment(thisMonth, "YYYYMM")
      .add(2, "months")
      .format("YYYYMMDD");

    let searchParamsNext3Month = JSON.parse(JSON.stringify(searchParams));
    searchParamsNext3Month.departureYMD = this.moment(thisMonth, "YYYYMM")
      .add(3, "months")
      .format("YYYYMMDD");

    Promise.all([
      this.planService.getPlanList(searchParams),
      this.planService.getPlanList(searchParamsNextMonth),
      this.planService.getPlanList(searchParamsNext2Month),
      this.planService.getPlanList(searchParamsNext3Month),
    ]).then((data) => {
      this.filterData.bestPriceList.thisMonth = data[0].price_calendar;
      this.filterData.bestPriceList.nextMonth = data[1].price_calendar;
      this.filterData.bestPriceList.next2Month = data[2].price_calendar;
      this.filterData.bestPriceList.next3Month = data[3].price_calendar;

      /* HIDE LOADER */
      this.commonService.hidePageLoader();
    });
  }

  updateURL(data: any, redirect: boolean = false) {
    let route = ``;

    /* CITY */
    if (
      this.searchParams.departureCityID != "" ||
      this.searchParams.destinationCityID != ""
    ) {
      route +=
        this.searchParams.departureCityID != ""
          ? `${
              this.filterData.divisionData.division_map.id_bb[
                this.searchParams.departureCityID
              ].slug
            }_`
          : `_`;
      route +=
        this.searchParams.destinationCityID != ""
          ? `${
              this.filterData.divisionData.division_map.id_bb[
                this.searchParams.destinationCityID
              ].slug
            }/`
          : `/`;
    }

    /* TOWN */
    if (
      this.searchParams.departureTownID != "" ||
      this.searchParams.destinationTownID != ""
    ) {
      route +=
        this.searchParams.departureTownID != ""
          ? `${
              this.filterData.townData.departure.map.id_bb[
                this.searchParams.departureTownID
              ].slug
            }_`
          : `_`;
      route +=
        this.searchParams.destinationTownID != ""
          ? `${
              this.filterData.townData.destination.map.id_bb[
                this.searchParams.destinationTownID
              ].slug
            }/`
          : `/`;
    }

    /* DATE */
    route += `${this.moment(data.date).format("YYYYMMDD")}`;

    if (redirect) {
      return this.commonService.redirectToRoute(
        `${this.commonService.routePaths.pagePlanListNoParam}/${route}`
      );
    } else {
      this.location.replaceState(
        `${this.commonService.routePaths.pagePlanListNoParam}/${route}`
      );
    }
  }
  /* END */

  /* BELONGS TO HISTORY */
  /* HISTORY */
  _getViewedPlans(event: any = {}) {
    let data = this.planService.getViewedPlans();
    if (data) {
      this.viewedPlans = data;

      /* RELOAD VIEWED PLANS FROM PARENT */
      this.getViewedPlans.emit();
    }
  }

  /* FAVORITE */
  _getFavouritePlans(event: any = {}) {
    let data = this.planService.getFavouritePlans();
    if (data) {
      this.favouritePlans = data;

      /* RELOAD FAVOURITE PLANS FROM PARENT */
      this.getFavouritePlans.emit();
    }
  }

  _setActivatedStation(event: any = {}) {
    this.activatedStation = event;
    this.setActivatedStation.emit(event);
  }
  /* END */

  inlineJS() {
    let self = this;

    this.$(function () {
      self.formValidationInit();

      /* INIT INPUT ZEN TO HAN */
      self.commonService.zenToHan();
    });

    /* CHECK PARENT MODAL IS STILL OPENED */
    self.$(document).on("hidden.bs.modal", ".modal", function () {
      if (self.$(".modal.show").length != 0) {
        self.$("body").addClass("modal-open");
      }
    });
    /* END */
  }

  formValidationInit() {
    let self = this;
    if (self.$(".js-birthday").length !== 0) {
      self.$(".js-birthday").each(function () {
        new Cleave(self.$(this), {
          delimiter: "/",
          blocks: [4, 2, 2],
        });
      });
    }
  }

  inlineJSRunOnce() {
    let self = this;

    /* DELETE HISTORY */
    self.$(document).on("click", "#mdl-history .cbAllPlanHistory", function () {
      if (self.$(this).is(":checked")) {
        self.$("#mdl-history .cbPlanHistory").prop("checked", true);
      } else {
        self.$("#mdl-history .cbPlanHistory").prop("checked", false);
      }
      checkCanDelete();
    });

    self.$(document).on("click", "#mdl-history .cbPlanHistory", function () {
      if (
        self.$("#mdl-history .cbPlanHistory:checked").length ===
        self.$("#mdl-history .cbPlanHistory").length
      ) {
        self.$("#mdl-history .cbAllPlanHistory").prop("checked", true);
      } else {
        self.$("#mdl-history .cbAllPlanHistory").prop("checked", false);
      }
      checkCanDelete();
    });

    let checkCanDelete = function () {
      if (self.$("#mdl-history .cbPlanHistory:checked").length !== 0) {
        self
          .$("#mdl-history .btnAllPlanHistory")
          .removeAttr("disabled", "disabled")
          .removeClass("disabled");
      } else {
        self
          .$("#mdl-history .btnAllPlanHistory")
          .attr("disabled", "disabled")
          .addClass("disabled");
      }
    };
  }

  /* DELETE HISTORY */
  deletePlanHistory() {
    let self = this;

    self.$("#mdl-history .cbPlanHistory:checked").each(function () {
      let id = self.$(this).attr("data-id");

      delete self.viewedPlans.keyMap[id];

      for (let i = 0; i < self.viewedPlans.list.length; i++) {
        if (self.viewedPlans.list[i].plan_code == id) {
          self.viewedPlans.list.splice(i, 1);
          break;
        }
      }
    });

    self
      .$("#mdl-history .btnAllPlanHistory")
      .attr("disabled", "disabled")
      .addClass("disabled");

    /* SAVE DATA */
    this.planService.savePlanViewedData(self.viewedPlans);

    /* RELOAD DATA */
    this._getViewedPlans({});
  }
}
